// Redux/actions/receptionistActions/receptionistActions.js
import API from "../../../api";
import {
  LOOKUP_PATIENT_REQUEST,
  LOOKUP_PATIENT_SUCCESS,
  LOOKUP_PATIENT_FAIL,
  LOOKUP_PATIENT_RESET,
  CREATE_WALKIN_REQUEST,
  CREATE_WALKIN_SUCCESS,
  CREATE_WALKIN_FAIL,
  FETCH_DEPARTMENTS_REQUEST,
  FETCH_DEPARTMENTS_SUCCESS,
  FETCH_DEPARTMENTS_FAIL,
  FETCH_DOCTORS_BY_DEPT_REQUEST,
  FETCH_DOCTORS_BY_DEPT_SUCCESS,
  FETCH_DOCTORS_BY_DEPT_FAIL,
  FETCH_APPOINTMENTS_REQUEST,
  FETCH_APPOINTMENTS_SUCCESS,
  FETCH_APPOINTMENTS_FAIL,
  ASSIGN_APPOINTMENT_REQUEST,
  ASSIGN_APPOINTMENT_SUCCESS,
  ASSIGN_APPOINTMENT_FAIL,
  REJECT_APPOINTMENT_REQUEST,
  REJECT_APPOINTMENT_SUCCESS,
  REJECT_APPOINTMENT_FAIL,
  COMPLETE_APPOINTMENT_REQUEST,
  COMPLETE_APPOINTMENT_SUCCESS,
  COMPLETE_APPOINTMENT_FAIL,
  PRINT_PAYMENT_RECEIPT_REQUEST,
  PRINT_PAYMENT_RECEIPT_SUCCESS,
  PRINT_PAYMENT_RECEIPT_FAIL,
  SEARCH_PATIENTS_REQUEST,
  SEARCH_PATIENTS_SUCCESS,
  SEARCH_PATIENTS_FAIL,
} from "../../constants/receptionistConstants/receptionistConstants";

// Lookup patient by email or MR-code
export const lookupPatient = (search) => async (dispatch) => {
  try {
    dispatch({ type: LOOKUP_PATIENT_REQUEST });

    const { data } = await API.get(`/receptionist/lookup-patient?search=${search}`);

    dispatch({
      type: LOOKUP_PATIENT_SUCCESS,
      payload: {
        patient: data.patient,
        aptExist: data.appointments, // ✅ This contains vitals
      },
    });

    // ✅ Returns aptExist which contains the appointment with vitals
    return { ok: true, patient: data.patient, aptExist: data.appointments };

  } catch (error) {
    const msg = error.response?.data?.msg || error.message;

    dispatch({ type: LOOKUP_PATIENT_FAIL, payload: msg });
    return { ok: false, error: msg };
  }
};
export const searchPatients = (query) => async (dispatch) => {
  try {
    dispatch({ type: SEARCH_PATIENTS_REQUEST });

    const { data } = await API.get(`/receptionist/search-patients?q=${encodeURIComponent(query)}`);

    dispatch({ type: SEARCH_PATIENTS_SUCCESS, payload: data.patients });
    return { ok: true, patients: data.patients };
  } catch (error) {
    const msg = error.response?.data?.msg || error.message;
    dispatch({ type: SEARCH_PATIENTS_FAIL, payload: msg });
    return { ok: false, error: msg };
  }
};

// Reset lookup
export const resetLookup = () => (dispatch) => {
  dispatch({ type: LOOKUP_PATIENT_RESET });
};

// Create walk-in appointment
export const createWalkInAppointment = (formData) => async (dispatch) => {
  try {
    dispatch({ type: CREATE_WALKIN_REQUEST });

    const { data } = await API.post("/receptionist/walk-in", formData);

    dispatch({ type: CREATE_WALKIN_SUCCESS, payload: data.appointment });
    return { ok: true, appointment: data.appointment, isNewPatient: data.isNewPatient };
  } catch (error) {
    const msg = error.response?.data?.msg || error.message;
    dispatch({ type: CREATE_WALKIN_FAIL, payload: msg });
    return { ok: false, error: msg };
  }
};

// Fetch departments
export const fetchDepartments = () => async (dispatch) => {
  try {
    dispatch({ type: FETCH_DEPARTMENTS_REQUEST });

    const { data } = await API.get("/receptionist/departments");

    dispatch({ type: FETCH_DEPARTMENTS_SUCCESS, payload: data });
    return { ok: true, departments: data };
  } catch (error) {
    const msg = error.response?.data?.msg || error.message;
    dispatch({ type: FETCH_DEPARTMENTS_FAIL, payload: msg });
    return { ok: false, error: msg };
  }
};

// Fetch doctors by department
export const fetchDoctorsByDepartment = (department) => async (dispatch) => {
  try {
    dispatch({ type: FETCH_DOCTORS_BY_DEPT_REQUEST });

    const { data } = await API.get(`/receptionist/doctors?department=${department}`);

    dispatch({ type: FETCH_DOCTORS_BY_DEPT_SUCCESS, payload: data });
    return { ok: true, doctors: data };
  } catch (error) {
    const msg = error.response?.data?.msg || error.message;
    dispatch({ type: FETCH_DOCTORS_BY_DEPT_FAIL, payload: msg });
    return { ok: false, error: msg };
  }
};

// Fetch all appointments
export const fetchAppointments = (filters = {}) => async (dispatch) => {
  try {
    dispatch({ type: FETCH_APPOINTMENTS_REQUEST });

    const queryString = new URLSearchParams(filters).toString();
    const { data } = await API.get(`/receptionist/appointments?${queryString}`);

    dispatch({ type: FETCH_APPOINTMENTS_SUCCESS, payload: data });
    return { ok: true, appointments: data };
  } catch (error) {
    const msg = error.response?.data?.msg || error.message;
    dispatch({ type: FETCH_APPOINTMENTS_FAIL, payload: msg });
    return { ok: false, error: msg };
  }
};

// Assign appointment
export const assignAppointment = (id, assignData) => async (dispatch) => {
  try {
    dispatch({ type: ASSIGN_APPOINTMENT_REQUEST });
    console.log(assignData)
    const { data } = await API.put(`/receptionist/appointments/${id}/assign`, assignData);
    dispatch({ type: ASSIGN_APPOINTMENT_SUCCESS, payload: data.appointment });
    return { ok: true, appointment: data.appointment };
  } catch (error) {
    const msg = error.response?.data?.msg || error.message;
    dispatch({ type: ASSIGN_APPOINTMENT_FAIL, payload: msg });
    return { ok: false, error: msg };
  }
};

// Reject appointment
export const rejectAppointment = (id, reason) => async (dispatch) => {
  try {
    dispatch({ type: REJECT_APPOINTMENT_REQUEST });

    const { data } = await API.put(`/receptionist/appointments/${id}/reject`, { reason });

    dispatch({ type: REJECT_APPOINTMENT_SUCCESS, payload: data.appointment });
    return { ok: true, appointment: data.appointment };
  } catch (error) {
    const msg = error.response?.data?.msg || error.message;
    dispatch({ type: REJECT_APPOINTMENT_FAIL, payload: msg });
    return { ok: false, error: msg };
  }
};

// Complete appointment
export const completeAppointment = (id) => async (dispatch) => {
  try {
    dispatch({ type: COMPLETE_APPOINTMENT_REQUEST });

    const { data } = await API.put(`/receptionist/appointments/${id}/complete`);

    dispatch({ type: COMPLETE_APPOINTMENT_SUCCESS, payload: data.appointment });
    return { ok: true, appointment: data.appointment };
  } catch (error) {
    const msg = error.response?.data?.msg || error.message;
    dispatch({ type: COMPLETE_APPOINTMENT_FAIL, payload: msg });
    return { ok: false, error: msg };
  }
};

// Print payment receipt
export const printPaymentReceipt = (id, paymentData) => async (dispatch) => {
  try {
    dispatch({ type: PRINT_PAYMENT_RECEIPT_REQUEST });

    const { data } = await API.put(`/receptionist/appointments/${id}/print-payment`, paymentData);

    dispatch({ type: PRINT_PAYMENT_RECEIPT_SUCCESS, payload: data.appointment });
    return { ok: true, appointment: data.appointment, receipt: data.receipt };
  } catch (error) {
    const msg = error.response?.data?.msg || error.message;
    dispatch({ type: PRINT_PAYMENT_RECEIPT_FAIL, payload: msg });
    return { ok: false, error: msg };
  }
};